export default "__VITE_ASSET__BtivsorE__"